import { Button, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import React, { useEffect } from "react";
import eKyc from "../../../../assets/images/kyc/Logo-eKYC.png";
import iconSvg from "../../../../assets/images/icon/check.svg";
import iconNext from "../../../../assets/images/icon/next-arrow.svg";
import "../../../../i18n/i18n";
import { i18n } from '../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../i18n/i18n.constants";

const DaolSecPage: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(namespaces.pages.daolSecKyc);
  // const paramFrom = localStorage.getItem("param_from");
  // const paramReques = localStorage.getItem("param_reques");
  const param_customer = localStorage.getItem("param_customer");

  useEffect(() => { }, [window.document.title = "DAOL - Review KYC"]);
  const onClickNext = () => {
    history.push({
      pathname: "/contents/daolSec/kyc/loginDate",
      state: {
        customerId: param_customer
      },
    });
  }

  return (
    <>
      <Row className="container-main daol-kyc">
        {console.log('useTranslation(namespaces.pages.daolSecKyc)', i18n.language)}
        {console.log('param_customerparam_customerparam_customer', param_customer)}
        <div className="content-right col-sm-8 text-center">
          <p className="text-header"><b>{t("title")}</b></p>
          <p>{t("text_descrip")}</p>
          <p><img src={eKyc} alt="Logo-eKYC" /></p>
          <p className="sub-text-header">{t("descrip_p1")}</p>

          <div className="text-left descrip-content">
          {(param_customer === "undefined" || param_customer === "")  ? (
              <>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p2")}</p>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p3")}</p>
                <span><img src={iconSvg} alt="icon" /></span>
                <span>{t("descrip_p4")}</span>
                <p className="remark-ekyc-sec">{t("descrip_p4_remark")}</p>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p5")}</p>
              </>
            ) : (
              <>
              <p><img src={iconSvg} alt="icon" />{t("descrip_p1_eng")}</p>
                <p><img src={iconSvg} alt="icon" />{t("descrip_p5")}</p>
              </>
            )}

          </div>
          {/* {console.log('localStorage.getItem("param_customer")', param_customer !== 'undefined')} */}
          <div className="container-button btn-kyc">
          {(param_customer === "undefined" || param_customer === "") ?
              (<span className="remark">{t("descrip_remark")}</span>) : ""}

            {param_customer === 'undefined' ? (<Button
              type="primary"
              className="btn-next"
              onClick={() => history.push(`/contents/daolSec/kyc/loginKyc`)}
            >
              {t("btn_next")}
              <img src={iconNext} alt="icon-next" />
            </Button>) :
              (<Button
                type="primary"
                className="btn-next"
                onClick={onClickNext}
              >
                {t("btn_next")}
                <img src={iconNext} alt="icon-next" />
              </Button>)}
          </div>
        </div>
      </Row>

    </>
  );
};
export default DaolSecPage;
